import React from 'react'
import PropTypes from 'prop-types'
import { Form } from 'react-bootstrap'

/**
 * @param {{
 *    id: string
 *    name: string
 *    label: string
 *    disabled?: boolean
 *    checked?: boolean
 *    value?: any
 * }} props
 * @returns {React.Component}
 */
const ZariCheckbox = props => {
  return (
    <div>
      <Form.Check {...props} custom type='checkbox' />
    </div>
  )
}

ZariCheckbox.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  checked: PropTypes.bool,
  value: PropTypes.any
}

export default ZariCheckbox
